var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtensils(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4654 28V6M24.4654 28C21.1494 28 18.4594 30.87 18.4594 33.25C18.4594 36.75 21.1494 42 24.4654 42C27.7814 42 30.4714 36.75 30.4714 33.25C30.4714 30.87 27.7814 28 24.4654 28ZM10.4574 20.056V42M7.8714 6.26L6.3074 6.414C6.03681 6.44072 5.77451 6.52233 5.53653 6.65385C5.29854 6.78536 5.08987 6.96403 4.92328 7.17892C4.75668 7.39381 4.63565 7.64042 4.56758 7.90367C4.49952 8.16692 4.48585 8.44129 4.5274 8.71L5.8654 17.342C6.0914 18.804 7.3514 20.022 8.8334 20.022H12.0794C13.5594 20.022 14.8194 18.804 15.0474 17.342L16.3874 8.71C16.429 8.44129 16.4153 8.16692 16.3472 7.90367C16.2792 7.64042 16.1581 7.39381 15.9915 7.17892C15.8249 6.96403 15.6163 6.78536 15.3783 6.65385C15.1403 6.52233 14.878 6.44072 14.6074 6.414L13.0474 6.258C11.3264 6.08584 9.59244 6.08584 7.8714 6.258M36.4914 27.636V6.052C38.8094 6.692 42.6634 9.106 43.3014 15.056L44.4474 24.084C44.6474 25.67 44.2454 27.252 42.6674 27.524C41.3474 27.75 39.3454 27.824 36.4914 27.636ZM36.4914 27.636V42",
    stroke: "#3B3B58",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtensils);
export default __webpack_public_path__ + "static/media/utensils.2ba8c626ca754078d59026d5264bb326.svg";
export { ForwardRef as ReactComponent };